// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__33Li4","label":"styles_label__3IO2g","select":"styles_select__vTyV0","error":"styles_error__i97Pz"};